import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class CentralMappingMarketSubscriptionChain extends Model {
  [Type] = 'central-mapping/market-subscription-chain' as const;

  @attr('string') declare name: string;
}
